// CSS Modules - component class name: Button__

<template>
  <div
    :class="[
      { Button__blue: colour === 'blue' },
      { Button__orange: colour === 'orange' },
      { Button__white: colour === 'white' },
      { Button__darkGrey: colour === 'darkGrey' },
      { Button__close: isClose },
      { Button__noBorder: noBorder },
      { Button__roundedCorners: roundedCorners },
      { Button__backArrow: backArrow },
      $style.button
    ]"
  >
    <a
      v-if="isLink"
      :href="href"
      :aria-label="ariaLabel"
      :target="targetBlank ? '_blank' : '_self'"
    >
      <span>{{ text }}</span>
    </a>
    <a
      v-else-if="isTabLink"
      :href="href"
      @click="handleTabLinkClick(tabID)"
      :aria-label="ariaLabel"
    >
      {{ text }}
    </a>
    <button
      v-else-if="isForm"
      :type="type"
      v-on:click.prevent="handleClick()"
      :aria-label="ariaLabel"
    >
      {{ text }}
    </button>
    <button
      v-else-if="!isLink && !isClose"
      :type="type"
      :disabled="isDisabled"
      @click="handleSimpleClick"
      :aria-label="ariaLabel"
    >
      {{ text }}
    </button>
    <button
      v-else-if="!isLink && isClose && !text"
      :class="$style.closeX"
      :type="type"
      v-html="rawHtml"
      v-on:click="handleClick"
      :aria-label="ariaLabel"
    ></button>
    <button
      v-else-if="!isLink && isClose && text"
      :type="type"
      v-on:click="handleClick"
      :aria-label="ariaLabel"
    >
      {{ text }}
    </button>
    <button
      v-else-if="!isLink && !isClose && isBack && text"
      :type="type"
      v-on:click="handleBackClick"
      :aria-label="ariaLabel"
    >
      {{ text }}
    </button>
  </div>
</template>

<script>
import CustomEvents from "../../globals/constants/customEvents";

export default {
  name: "Button",
  props: {
    colour: {
      type: String,
      default: "blue"
    },
    href: String,
    isBack: {
      type: Boolean,
      default: false
    },
    isClose: {
      type: Boolean,
      default: false
    },
    isLink: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "button",
      validator: value => ["button", "submit", "reset"].indexOf(value) >= 0
    },
    isForm: {
      type: Boolean,
      default: false
    },
    noBorder: {
      type: Boolean,
      default: false
    },
    isTabLink: {
      type: Boolean,
      default: false
    },
    tabID: {
      type: String,
      default: ""
    },
    ariaLabel: {
      type: String,
      default: undefined
    },
    roundedCorners: {
      type: Boolean,
      default: false
    },
    targetBlank: {
      type: Boolean,
      default: false
    },
    backArrow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rawHtml: "&times;"
    };
  },
  methods: {
    handleClick() {
      this.$emit("close");
    },
    handleSimpleClick() {
      this.$emit("onSimpleClick");
    },
    handleTabLinkClick(tabID) {
      window.dispatchEvent(
        new CustomEvent(CustomEvents.OPEN_TAB_FROM_LINK, {
          detail: tabID
        })
      );
    },
    handleBackClick() {
      window.history.back();
    }
  }
};
</script>

<style module lang="scss">
@import "./Button.scss";
</style>
